export const showBadgeOnFavicon = () => {
  document.querySelector('link[rel="shortcut icon"]').href =
    '/favicon_badge.ico';
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      document.querySelector('link[rel="shortcut icon"]').href = '/favicon.ico';
    }
  });
};
